import React from 'react';
import VideoBanner from 'components/video-banner';
import FeaturePanel from 'components/feature-panel';
import Map from 'components/map';
import VacationPanel from 'components/vacation-panel';
import QualityPanel from 'components/quality-panel';
import ContactUsPanel from 'components/contact-us-panel';
import GalleryPanel from 'components/gallery';
import Reviews from 'components/reviews';
import FloatingMenu from 'components/floating-menu';
import './styles.css';

const Home: React.FC = () => (
  <div>
    <VideoBanner />
    <FeaturePanel />
    <Map />
    <GalleryPanel />
    <VacationPanel />
    <Reviews />
    <QualityPanel />
    <ContactUsPanel />
    <FloatingMenu />
  </div>
);

export default Home;
